import { useT } from "../../../shared/i18n";
import { Banner } from "../../../shared/ui";
import { MasterPane } from "../AdminListRow";
import { adminHref, type UserTabId } from "../adminRoute";
import type { TraceApi } from "../logs";
import { UserList } from "./UserList";
import { UserPage } from "./UserPage";
import type { UsersApi } from "./usersApi";

/**
 * Users section. Wide: list (master) beside the routed user page. Narrow: the
 * list at /admin/users, the user page at /admin/users/{id} with a back header.
 */
export function UsersPage({
  api,
  traceApi,
  wide,
  userId,
  tab,
  onNavigate,
}: {
  api: UsersApi;
  traceApi: TraceApi;
  wide: boolean;
  userId: string | null;
  tab: UserTabId;
  onNavigate: (href: string) => void;
}) {
  const t = useT();
  const list = (
    <MasterPane label={t("admin.users.title")}>
      <UserList
        api={api}
        selectedId={userId}
        hrefFor={(id) => adminHref({ section: "users", userId: id })}
        onOpen={(id) => {
          onNavigate(adminHref({ section: "users", userId: id }));
        }}
      />
    </MasterPane>
  );
  const page =
    userId === null ? null : (
      <UserPage
        key={userId}
        api={api}
        traceApi={traceApi}
        userId={userId}
        tab={tab}
        wide={wide}
        onNavigate={onNavigate}
        onBack={
          wide
            ? undefined
            : () => {
                onNavigate(adminHref({ section: "users" }));
              }
        }
      />
    );
  return (
    <section className="flex flex-col gap-3">
      {(wide || page === null) && (
        <>
          <h2 className="text-title text-fg">{t("admin.users.title")}</h2>
          <Banner tone="info">{t("admin.users.notice")}</Banner>
        </>
      )}
      {wide ? (
        <div className="grid min-w-0 grid-cols-[minmax(260px,340px)_minmax(0,1fr)] items-start gap-5">
          {list}
          {page ?? (
            <p className="rounded-xl bg-sunken p-6 text-body text-fg-muted">
              {t("admin.users.pick")}
            </p>
          )}
        </div>
      ) : (
        (page ?? list)
      )}
    </section>
  );
}
